// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.try-again-btn {
    color: #ffffff !important;
    background-color: #008080 !important;
    font-weight: 400 !important;
    font-size: 12px !important;
    text-transform: unset !important;
    min-width: 11.5em !important;
    padding: 0.5em 1em !important;
    border-radius: 4px;
}

.try-again-btn:hover {
    color: #ffffff !important;
    background-color: #006666 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ErrorFallBack/ErrorFallBack.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,2BAA2B;IAC3B,0BAA0B;IAC1B,gCAAgC;IAChC,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC","sourcesContent":[".try-again-btn {\n    color: #ffffff !important;\n    background-color: #008080 !important;\n    font-weight: 400 !important;\n    font-size: 12px !important;\n    text-transform: unset !important;\n    min-width: 11.5em !important;\n    padding: 0.5em 1em !important;\n    border-radius: 4px;\n}\n\n.try-again-btn:hover {\n    color: #ffffff !important;\n    background-color: #006666 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
